export const GRAPH_FOLLOW_UP_PRESET_KEY = 'graph-follow-up-after-3-days';

export const GRAPH_FOLLOW_UP_DEFAULT_NAME = 'Graph follow-up after 3 days';

export const GRAPH_FOLLOW_UP_DEFAULT_DESCRIPTION =
  'Wait three days after a deal reaches Contacted, analyze risk, request approval, and queue a follow-up email.';

export const GRAPH_FOLLOW_UP_EMAIL_SUBJECT = 'Following up on your recent inquiry';

export const GRAPH_FOLLOW_UP_EMAIL_BODY =
  'Hello,\n\nThank you for contacting us. We wanted to follow up on your recent inquiry and offer help with the next steps.\n\nPlease reply to this email if you would like to continue.\n\nBest regards';

const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000;

/**
 * Public-client projection of the canonical backend preset. Keep this exact:
 * the API verifies the reserved id against the compiled plan hash.
 */
export function buildGraphFollowUpConfig(): Record<string, unknown> {
  return {
    id: GRAPH_FOLLOW_UP_PRESET_KEY,
    version: 1,
    nodes: [
      {
        id: 'trigger',
        type: 'trigger',
        params: { kind: 'event', eventType: 'deal.stage.changed', toStage: 'Contacted' },
      },
      { id: 'wait3d', type: 'delay', params: { durationMs: THREE_DAYS_MS } },
      {
        id: 'risk',
        type: 'tool',
        params: { tool: 'analyze_deal_risk', args: { dealId: '{{trigger.dealId}}' } },
      },
      { id: 'approval', type: 'approval', params: { requires: 'destructive' } },
      {
        id: 'email',
        type: 'tool',
        params: {
          tool: 'queue_deal_email',
          args: {
            dealId: '{{trigger.dealId}}',
            subject: GRAPH_FOLLOW_UP_EMAIL_SUBJECT,
            body: GRAPH_FOLLOW_UP_EMAIL_BODY,
          },
        },
      },
      { id: 'end', type: 'end', params: {} },
    ],
    edges: [
      { id: 'e1', from: 'trigger', to: 'wait3d' },
      { id: 'e2', from: 'wait3d', to: 'risk' },
      { id: 'e3', from: 'risk', to: 'approval' },
      { id: 'e4', from: 'approval', to: 'email' },
      { id: 'e5', from: 'email', to: 'end' },
    ],
  };
}
